let utag: {link: (_: Record<string, string>) => void; view: (_: Record<string, string | number>) => void;};

const utagPromise = new Promise<typeof utag>(resolve => {
  if (typeof window.utag !== 'undefined') {
    resolve(window.utag);
  } else {
    Object.defineProperty(window, 'utag', {
      set: newValue => {
        utag = newValue;
        resolve(newValue);
      },
      get() {
        return utag;
      },
    });
  }
});

const link = async (event: Record<string, string>) => {
  (await utagPromise).link(event);
};

const view = async (event: Record<string, string | number>) => {
  (await utagPromise).view(event);
};

export default { link, view };
